import {connect} from 'react-redux';
import {actions} from '../../actions/actions';
import {FirebaseAPI} from '../firebaseAPI';

export const FirebaseAPIContainer = connect(
  function mapStateToProps(state) {
    return {
      authenticated: state.authReducer.authenticated,
      online: state.onlineReducer.online,
      coffees: state.coffeeReducer.coffees,
      loginRequestEmail: state.authReducer.loginRequestEmail,
      loginRequestPW: state.authReducer.loginRequestPW,
      loginRequestStatus: state.authReducer.loginRequestStatus,
      logoutRequest: state.authReducer.logoutRequest,
      registerRequestEmail: state.authReducer.registerRequestEmail,
      registerRequestPW: state.authReducer.registerRequestPW,
      registerRequestStatus: state.authReducer.registerRequestStatus,
      displayName: state.authReducer.displayName,
      card: state.ecommReducer.card,
      deleteCard: state.ecommReducer.deleteCard,
      cardSubmitted: state.ecommReducer.submitted,
      userName: state.authReducer.userName,
      donation: state.ecommReducer.donation,
      donationCompleted: state.ecommReducer.completed,
      fileUpload: state.uploadReducer.file,
      uploadStatus: state.uploadReducer.status
    };
  },
  function mapDispatchToProps(dispatch){
      return{
        onAuthenticationChange: (bool) => {
         if(bool){
           dispatch( actions.authenticate() );
         }else{
           dispatch( actions.unauthenticate() );
         }
        },
        onLoginRequestStatus: (email, pw, status ) => {
         dispatch(actions.logIn(email, pw, status));
       },
       onRegisterRequestStatus: (email, pw, status) =>{
         dispatch(actions.register(email, pw, status))
       },
        onOnlineStatusChange: (bool) => {
         if(bool){
           dispatch( actions.online() );
         }else{
           dispatch( actions.offline() );
         }
        },
        onSync: (amt)=>{
            dispatch( actions.sync(amt));
        },
        onUser: (user, status="normal")=>{
            console.log("FirebaseAPIContainer hears user...");
            dispatch( actions.user(user, status) )
        },
        onUserPrefs: (prefs)=>{
            dispatch( actions.prefs(prefs) )
        },
        onUserCard: (card)=>{
            dispatch( actions.card(card, true) );
        },
        onDeleteCard: ()=>{
          dispatch( actions.deleteCard(false) );
        },
        onDonationComplete: ()=>{
          //this should indicate the donation is done??....t.w.
          dispatch( actions.donate(0,false) );
        },
        onCharges: (charges)=>{
          dispatch( actions.charges(charges) );
        },
        onError: (message)=>{
          dispatch( actions.error(message) );
        },
        onUploadStatus: (file, status)=>{
          dispatch( actions.fileUpload(file, status));
        },
        onUploadProgress: (progress)=>{
          dispatch( actions.fileUploadProgress(progress))
        },
        onStats: (stats)=>{
          dispatch( actions.stats(stats) );
        }
      }
  }

)(FirebaseAPI);



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/containers/firebaseAPIContainer.js